<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Plan</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/plan" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="update" v-if="plan">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="plan.name"
                                          label="Name"
                                          placeholder="Enter Name"
                                          v-validate="rules.name"
                                          data-vv-name="name"
                                          cus-name="name"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-4" v-if="status.length">
                                <fg-select
                                        v-model="plan.active"
                                        label="Status"
                                        v-validate="rules.active"
                                        data-vv-name="active"
                                        cus-name="active"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="status"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="plan.amount"
                                          label="Amount"
                                          placeholder="Enter Amount"
                                          v-validate="rules.amount"
                                          data-vv-name="amount"
                                          cus-name="amount"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.type"
                                          label="Type"
                                          placeholder="Enter Type"
                                          v-validate="rules.type"
                                          data-vv-name="type"
                                          cus-name="type"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          disabled>
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.startDate"
                                          label="Start Date"
                                          placeholder="Enter start date"
                                          v-validate="rules.startDate"
                                          data-vv-name="startDate"
                                          cus-name="startDate"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          disabled>
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.endDate"
                                          label="End Date"
                                          placeholder="Enter end date"
                                          v-validate="rules.endDate"
                                          data-vv-name="endDate"
                                          cus-name="endDate"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          disabled>
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.chargeNow"
                                          label="Charge Now"
                                          placeholder="Enter charge now"
                                          v-validate="rules.chargeNow"
                                          data-vv-name="chargeNow"
                                          cus-name="chargeNow"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          disabled>
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.couponcode"
                                          label="Coupon Code"
                                          placeholder="Enter coupon code"
                                          v-validate="rules.couponcode"
                                          data-vv-name="couponcode"
                                          cus-name="couponcode"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          disabled>
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="plan.finalAmount"
                                          label="Final Amount"
                                          placeholder="Enter final amount"
                                          v-validate="rules.finalAmount"
                                          data-vv-name="finalAmount"
                                          cus-name="finalAmount"
                                          :has-errors="errors"
                                          :is-fields="fields"
                                          disabled>
                                </fg-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <fg-text-area
                                        rows="2"
                                        v-model="plan.description"
                                        label="Description"
                                        placeholder="Enter Description"
                                        v-validate="rules.description"
                                        data-vv-name="description"
                                        cus-name="description"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        disabled>
                                </fg-text-area>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Plan
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditPlan',
        created (){
        this.$store.dispatch('GET_SELECTED_PLAN', this.$route.params.id)
                .then((res) => {
                    if(this.plan && this.plan.active == null) this.plan.active = 0;
                })
                .catch((err) => {
                    console.log("GET_SELECTED_PLAN err : ", err)
                })
    },
    data () {
        return {
            /*plan: {
             name : "",
             active : null,
             amount : 0,
             discount : 0,
             startDate : "",
             endDate : "",
             chargeNow : "",
             couponId : 0,
             couponcode : null,
             description : "",
             finalAmount : null,
             partnerPlanId : null,
             paypalPlanId : null,
             paypalSubscriptionId : null,
             stripePlanSubscriptionId : null,
             type : "",
             userId : null
             },*/
            rules: {
                name : {required: true},
                active : {required: true},
                amount : {required: true},
                type : {required: false},
                chargeNow : {required: false},
                couponcode : {required: false},
                description : {required: false},
                startDate : {required: false},
                endDate : {required: false},
                finalAmount : {required: false}
            },
            status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        }
    },
    methods: {
        update () {
            this.$validator.validateAll().then((result) => {
                if(result){
                    let updatePlan = () =>{
                        let obj = {
                            id: this.plan.packageId,
                            payload: {
                                name:this.plan.name,
                                active:this.plan.active,
                                amount:this.plan.amount,
                                discount:this.plan.discount
                            }
                        }
                        this.$store.dispatch('UPDATE_PLAN', obj)
                                .then((res) => {
                                    console.log("UPDATE_PLAN res : ", res);
                                    this.showPopup('Success!', 'Plan is successfully updated', 'success', ()=>this.$router.push('/admin/plan'))
                                })
                                .catch(err => {
                                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                                    console.log("UPDATE_PLAN API error : ", err);
                                })
                    };
                    updatePlan();
                }
            })
            console.log("this.plan : ", this.plan);
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {
    ...mapGetters({
            plans: 'plans',
            selectedPlan: 'selectedPlan',
        }),
        plan(){
            return this.selectedPlan
        }
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Plans/EditPlan.vue